import { z } from "zod";
import {
  changeMsisdnOrchestrator,
  changeSimEsimOrchestrator,
  fsecureOrchestrator,
  fsecureReactivationOrchestrator,
  ftthOrchestrator,
  ftthReactivationOrchestrator,
  groupOrchestrator,
  mobileOrchestrator,
  mobileReactivationOrchestrator,
  modemReturnOrchestrator,
  multiOrderOrchestrator,
  tvOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export const serverResponse = z.array(
  z.union([
    ftthOrchestrator,
    modemReturnOrchestrator,
    ftthReactivationOrchestrator,
    mobileReactivationOrchestrator,
    mobileOrchestrator,
    changeMsisdnOrchestrator,
    groupOrchestrator,
    tvOrchestrator,
    multiOrderOrchestrator,
    changeSimEsimOrchestrator,
    fsecureOrchestrator,
    fsecureReactivationOrchestrator,
  ]),
);
